import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Marcela G.',
  role: 'Docente técnica agropecuaria — Córdoba, Argentina',
  text: '"Mis alumnos por fin entienden la diferencia entre sistemas de producción extensivo e intensivo. Antes yo misma perdía tiempo buscando cómo explicarlo bien. Ahora entro al aula con todo listo."'
}, {
  initials: 'JR',
  name: 'Juan R.',
  role: 'Profesor técnico agropecuario — Bogotá, Colombia',
  text: '"Nunca más llegué a clase sin saber cómo explicar el ciclo del cultivo o la diferencia entre riego por aspersión y goteo. El material hace el trabajo pesado por mí."'
}, {
  initials: 'LV',
  name: 'Lorena V.',
  role: 'Docente rural — Asunción, Paraguay',
  text: '"Las planificaciones me ahorran horas cada semana. No improviso nunca más frente a mis alumnos."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-white border-y border-earth/20" data-id="element-268" data-mp="ccpihssxx3dt">
      <div className="max-w-7xl mx-auto px-4" data-id="element-269" data-mp="cek3f747ovhw">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-270" data-mp="gdswsavcarcx">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-cream border border-earth/10 p-6 rounded-2xl relative shadow-sm" data-id="element-271" data-mp="ldnmwc7ajcwx" data-mpi={i}>
              <div className="flex gap-1 text-gold mb-4" data-id="element-272" data-mp="192zx9fectr0t">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-273" data-mp="35vi4xxhly7t8" data-mpi={j} />)}
              </div>
              <p className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-274" data-mp="3au39g93w7dnh">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-275" data-mp="i0w5avt8oegj">
                <div className="w-10 h-10 rounded-full bg-forest/10 border border-forest flex items-center justify-center text-forest font-bold" data-id="element-276" data-mp="d0rp76w8tlqu">
                  {t.initials}
                </div>
                <div data-id="element-277" data-mp="m1g2fzdtbi2o">
                  <div className="font-bold text-slate-900 text-sm" data-id="element-278" data-mp="m0y9pcqczlzi">
                    {t.name}
                  </div>
                  <div className="text-xs text-earth" data-id="element-279" data-mp="10xp2v49fw1go">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}